export const FETCH_TOKEN = 'FETCH_TOKEN';
export const CREATE_TOKEN = 'CREATE_TOKEN';
export const UPDATE_TOKEN_A = 'UPDATE_TOKEN_A';
